import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [ "goback" ]
    connect()
    {
        this.gobackTarget.addEventListener("click", e =>
        {
            history.back();
        })
    }
}